import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import MediaProcessJob from './media-process-job-model'
import {
  CreateMediaProcessJobAsync,
  DeleteMediaProcessJobAsync,
  LoadMediaProcessJobsAsync,
} from './mediaProcessJob-thunk'
const initialState: mediaProcessJobSliceState = {
  mediaProcessJob: [],
  selected_mediaProcessJob: '',
  is_loading_mediaProcessJob: false,
  is_creating_mediaProcessJob: false,
  is_deleting_mediaProcessJob: false,
}
export interface mediaProcessJobSliceState {
  mediaProcessJob: MediaProcessJob[]
  selected_mediaProcessJob?: string
  is_loading_mediaProcessJob: boolean
  is_creating_mediaProcessJob: boolean
  is_deleting_mediaProcessJob: boolean
}
export const mediaProcessJobSlice = createSlice({
  name: 'mediaProcessJob',
  initialState,
  reducers: {
    setSelectedmediaProcessJob: (state, action) => {
      state.selected_mediaProcessJob = action.payload
    },
    clearStatemediaProcessJob: (state) => {
      state.mediaProcessJob = []
      state.is_loading_mediaProcessJob = false
      state.is_creating_mediaProcessJob = false
      state.is_deleting_mediaProcessJob = false
    },
    mergemediaProcessJob: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaProcessJob = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaProcessJob = merge(state.mediaProcessJob, payload) as any
        }
      }
    },

    add_mediaProcessJob: (state, action) => {
      if (action.payload) {
        state.mediaProcessJob = [...state.mediaProcessJob, action.payload]
      }
    },
    set_mediaProcessJob: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaProcessJob = state.mediaProcessJob.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaProcessJobsAsync.pending, (state) => {
      state.is_loading_mediaProcessJob = true
    })
    builder.addCase(LoadMediaProcessJobsAsync.fulfilled, (state, action) => {
      state.is_loading_mediaProcessJob = false
      if (action.payload) {
        state.mediaProcessJob = action.payload
      }
    })
    builder.addCase(LoadMediaProcessJobsAsync.rejected, (state) => {
      state.is_loading_mediaProcessJob = false
    })
    builder.addCase(CreateMediaProcessJobAsync.pending, (state) => {
      state.is_creating_mediaProcessJob = true
    })
    builder.addCase(CreateMediaProcessJobAsync.fulfilled, (state) => {
      state.is_creating_mediaProcessJob = false
    })
    builder.addCase(CreateMediaProcessJobAsync.rejected, (state) => {
      state.is_creating_mediaProcessJob = false
    })
    builder.addCase(DeleteMediaProcessJobAsync.pending, (state) => {
      state.is_deleting_mediaProcessJob = true
    })
    builder.addCase(DeleteMediaProcessJobAsync.fulfilled, (state, action) => {
      state.is_deleting_mediaProcessJob = false
      if (state.mediaProcessJob) {
        state.mediaProcessJob = state.mediaProcessJob.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediaProcessJobAsync.rejected, (state) => {
      state.is_deleting_mediaProcessJob = false
    })

    builder.addCase(
      autoThunks.retrieve_media_processing_job.pending,
      (state) => {
        state.is_loading_mediaProcessJob = true
      },
    )
    builder.addCase(
      autoThunks.retrieve_media_processing_job.fulfilled,
      (state, action) => {
        state.is_loading_mediaProcessJob = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.retrieve_media_processing_job.rejected,
      (state) => {
        state.is_loading_mediaProcessJob = false
      },
    )

    builder.addCase(
      autoThunks.reset_failed_processing_jobs.pending,
      (state) => {
        state.is_loading_mediaProcessJob = true
      },
    )
    builder.addCase(
      autoThunks.reset_failed_processing_jobs.fulfilled,
      (state, action) => {
        state.is_loading_mediaProcessJob = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.reset_failed_processing_jobs.rejected,
      (state) => {
        state.is_loading_mediaProcessJob = false
      },
    )
  },
})

function handleResult(action: any, state: mediaProcessJobSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_mediaProcessJob = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.mediaProcessJob = merge(state.mediaProcessJob, payload) as any
    }
  }
}

export const {
  clearStatemediaProcessJob,
  setSelectedmediaProcessJob,
  set_mediaProcessJob,
  mergemediaProcessJob,
  add_mediaProcessJob,
} = mediaProcessJobSlice.actions

export const get_mediaProcessJob =
  (id?: string) =>
  (state: {
    mediaProcessJob: {
      mediaProcessJob: MediaProcessJob[]
    }
  }): MediaProcessJob | null => {
    let temp = state?.mediaProcessJob?.mediaProcessJob?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.mediaProcessJob?.mediaProcessJob[0] || null
  }
export const get_selected_mediaProcessJob = (state: {
  mediaProcessJob: mediaProcessJobSliceState
}): MediaProcessJob | null => {
  let id = state?.mediaProcessJob?.selected_mediaProcessJob
  let temp = state?.mediaProcessJob?.mediaProcessJob?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaProcessJob = (state: {
  mediaProcessJob: {
    mediaProcessJob: MediaProcessJob[]
  }
}): MediaProcessJob[] => {
  let temp = state?.mediaProcessJob?.mediaProcessJob
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaProcessJob_busy = (state: {
  mediaProcessJob: mediaProcessJobSliceState
}) => {
  return (
    state?.mediaProcessJob.is_deleting_mediaProcessJob ||
    state?.mediaProcessJob.is_loading_mediaProcessJob ||
    state?.mediaProcessJob.is_creating_mediaProcessJob
  )
}
export const is_deleting_mediaProcessJob_busy = (state: {
  mediaProcessJob: mediaProcessJobSliceState
}) => {
  return state?.mediaProcessJob.is_deleting_mediaProcessJob
}
export const is_loading_mediaProcessJob_busy = (state: {
  mediaProcessJob: mediaProcessJobSliceState
}) => {
  return state?.mediaProcessJob.is_loading_mediaProcessJob
}
export const is_creating_mediaProcessJob_busy = (state: {
  mediaProcessJob: mediaProcessJobSliceState
}) => {
  return state?.mediaProcessJob.is_creating_mediaProcessJob
}

export default mediaProcessJobSlice.reducer
